export const FIRST_SCREEN_STATIC = {
    "ro": {
        "web.personalized.plan": "Primește un plan de învățare personalizat în funcție de obiectivele tale",
        "web.quiz.3min": "Chestionar de 3 minute",
        "web.profile.age": "Vârsta dvs.",
        "web.unlock.english.potential": "Descoperă-ți potențialul în limba engleză",
        "screen.practice.guide.control.next": "Următorul",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " și ",
        "web.common.privacyPolicy": "Politica de confidențialitate",
        "web.common.ratingAlt": "5 din 5 stele",
        "web.common.termsOfUse": "Termeni de utilizare",
        "web.start.heroAlt": "Lola, tutorele dumneavoastră AI",
        "web.start.statsLabel": "Peste 2 milioane de utilizatori, evaluare medie 4,8, peste 125.000 de evaluări",
        "web.start.title": "Vorbiți engleza cu mai multă încredere",
        "web.start.review1.text": "Aplicație excelentă pentru exersarea conversației. Puteți lucra în ritmul propriu, fără limitări",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Aplicație pentru exersarea conversațiilor necesare pentru viața în SUA 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "O aplicație care vă face să vorbiți într-un mod foarte blând, fără stres",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "evaluare medie",
        "onboarding.good.company.ratings": "evaluări",
        "screen.paywall.users": "utilizatorii",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125.000+",
        "web.start.statUsersValue": "2+ milioane"
    },
    "ru": {
        "web.personalized.plan": "Получите персональный план обучения, разработанный с учетом\n        ваших целей",
        "web.quiz.3min": "Тест на 3 минуты",
        "web.profile.age": "Ваш возраст",
        "web.unlock.english.potential": "Раскройте свой потенциал в английском языке",
        "screen.practice.guide.control.next": "Далее",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " и ",
        "web.common.privacyPolicy": "Политика конфиденциальности",
        "web.common.ratingAlt": "5 из 5 звёзд",
        "web.common.termsOfUse": "Условия использования",
        "web.start.heroAlt": "Лола, ваш AI-тьютор",
        "web.start.statsLabel": "Более 2 млн пользователей, средняя оценка 4,8, более 125 000 оценок",
        "web.start.title": "Говорите по‑английски увереннее",
        "web.start.review1.text": "Отличное приложение для разговорной практики. Занимаетесь в своём темпе, без ограничений",
        "web.start.review1.author": "Тина",
        "web.start.review2.text": "Приложение для тренировки разговоров, которые нужны для жизни в США 🙂",
        "web.start.review2.author": "Борис",
        "web.start.review3.text": "Приложение, которое очень мягко разговаривает вас, без стресса",
        "web.start.review3.author": "Лусия",
        "onboarding.good.company.average.rating": "средний рейтинг",
        "onboarding.good.company.ratings": "оценок",
        "screen.paywall.users": "пользователей",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ млн"
    },
    "it": {
        "web.personalized.plan": "Ottieni un piano di apprendimento personalizzato in base ai tuoi obiettivi",
        "web.quiz.3min": "Quiz di 3 minuti",
        "web.profile.age": "La Sua età",
        "web.unlock.english.potential": "Sblocca il tuo potenziale in inglese",
        "screen.practice.guide.control.next": "Avanti",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " e ",
        "web.common.privacyPolicy": "Informativa sulla privacy",
        "web.common.ratingAlt": "5 stelle su 5",
        "web.common.termsOfUse": "Termini di utilizzo",
        "web.start.heroAlt": "Lola, la Sua tutor IA",
        "web.start.statsLabel": "Oltre 2 milioni di utenti, valutazione media 4,8, oltre 125.000 valutazioni",
        "web.start.title": "Parli inglese con più sicurezza",
        "web.start.review1.text": "Ottima app per fare pratica di conversazione. Si va al proprio ritmo, senza limiti",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Un'app per esercitarsi nelle conversazioni necessarie per vivere negli USA 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Un'app che ti fa parlare in modo molto delicato, senza stress",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "valutazione media",
        "onboarding.good.company.ratings": "giudizi",
        "screen.paywall.users": "utenti",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125.000+",
        "web.start.statUsersValue": "2+ milioni"
    },
    "cs": {
        "web.personalized.plan": "Získejte personalizovaný studijní plán přizpůsobený vašim\n        cílům",
        "web.quiz.3min": "Tříminutový kvíz",
        "web.profile.age": "Váš věk",
        "web.unlock.english.potential": "Odemkněte svůj potenciál v angličtině",
        "screen.practice.guide.control.next": "Další",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " a ",
        "web.common.privacyPolicy": "Zásady ochrany osobních údajů",
        "web.common.ratingAlt": "5 z 5 hvězdiček",
        "web.common.termsOfUse": "Podmínky použití",
        "web.start.heroAlt": "Lola, vaše AI lektorka",
        "web.start.statsLabel": "Přes 2 miliony uživatelů, průměrné hodnocení 4,8, přes 125 000 hodnocení",
        "web.start.title": "Mluvte anglicky s větší jistotou",
        "web.start.review1.text": "Skvělá aplikace na procvičování mluvení. Můžete se učit vlastním tempem, bez omezení",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Aplikace na procvičování rozhovorů, které člověk potřebuje k životu v USA 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Aplikace, která vás velmi jemně a bez stresu rozmluví",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "průměrné hodnocení",
        "onboarding.good.company.ratings": "hodnocení",
        "screen.paywall.users": "uživatelů",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ milionů"
    },
    "pt-BR": {
        "web.personalized.plan": "Obtém um plano de aprendizagem personalizado adaptado aos teus objetivos",
        "web.quiz.3min": "Questionário de 3 minutos",
        "web.profile.age": "Sua idade",
        "web.unlock.english.potential": "Desbloqueia o teu potencial em inglês",
        "screen.practice.guide.control.next": "Próximo",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " e ",
        "web.common.privacyPolicy": "Política de Privacidade",
        "web.common.ratingAlt": "5 de 5 estrelas",
        "web.common.termsOfUse": "Termos de Uso",
        "web.start.heroAlt": "Lola, sua tutora de IA",
        "web.start.statsLabel": "Mais de 2 milhões de usuários, nota média 4,8, mais de 125.000 avaliações",
        "web.start.title": "Fale inglês com mais confiança",
        "web.start.review1.text": "Ótimo app para praticar conversação. Você estuda no seu ritmo, sem limitações",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "App para praticar as conversas necessárias para morar nos EUA 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Um app que faz você falar de um jeito bem leve, sem estresse",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "classificação média",
        "onboarding.good.company.ratings": "classificações",
        "screen.paywall.users": "Usuários",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125.000+",
        "web.start.statUsersValue": "2+ milhões"
    },
    "in": {
        "web.personalized.plan": "Dapatkan rencana belajar pribadi yang disesuaikan dengan tujuanmu",
        "web.quiz.3min": "Kuis 3 menit",
        "web.profile.age": "Usia Anda",
        "web.unlock.english.potential": "Tingkatkan potensi Bahasa Inggrismu",
        "screen.practice.guide.control.next": "Berikutnya",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " & ",
        "web.common.privacyPolicy": "Kebijakan Privasi",
        "web.common.ratingAlt": "5 dari 5 bintang",
        "web.common.termsOfUse": "Ketentuan Penggunaan",
        "web.start.heroAlt": "Lola, tutor AI Anda",
        "web.start.statsLabel": "Lebih dari 2 juta pengguna, rating rata-rata 4,8, lebih dari 125.000 ulasan",
        "web.start.title": "Berbicara bahasa Inggris dengan lebih percaya diri",
        "web.start.review1.text": "Aplikasi yang bagus untuk latihan berbicara. Anda bisa belajar sesuai kecepatan sendiri tanpa batasan",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Aplikasi untuk melatih percakapan yang dibutuhkan untuk tinggal di Amerika Serikat 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Aplikasi yang membuat Anda berbicara dengan cara yang sangat lembut, tanpa stres",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "rating rata-rata",
        "onboarding.good.company.ratings": "penilaian",
        "screen.paywall.users": "pengguna",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125.000+",
        "web.start.statUsersValue": "2+ juta"
    },
    "ja": {
        "web.personalized.plan": "あなたの目標に合わせた学習プランを作成します",
        "web.quiz.3min": "3分クイズ",
        "web.profile.age": "ご年齢",
        "web.unlock.english.potential": "英語の可能性を引き出そう",
        "screen.practice.guide.control.next": "次へ",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": "と",
        "web.common.privacyPolicy": "プライバシーポリシー",
        "web.common.ratingAlt": "5つ星中5つ星",
        "web.common.termsOfUse": "利用規約",
        "web.start.heroAlt": "AIチューターのローラ",
        "web.start.statsLabel": "ユーザー200万人以上、平均評価4.8、評価数125,000件以上",
        "web.start.title": "もっと自信を持って英語を話しましょう",
        "web.start.review1.text": "スピーキング練習にぴったりのアプリです。制限なく、自分のペースで学べます",
        "web.start.review1.author": "ティナ",
        "web.start.review2.text": "アメリカでの生活に必要な会話を練習できるアプリです 🙂",
        "web.start.review2.author": "ボリス",
        "web.start.review3.text": "ストレスなく、とても自然に話せるようにしてくれるアプリです",
        "web.start.review3.author": "ルシア",
        "onboarding.good.company.average.rating": "平均評価",
        "onboarding.good.company.ratings": "評価",
        "screen.paywall.users": "ユーザー",
        "web.start.statRatingValue": "4.8",
        "web.start.statRatingsValue": "125,000+",
        "web.start.statUsersValue": "200万+"
    },
    "el": {
        "web.personalized.plan": "Αποκτήστε ένα εξατομικευμένο πλάνο μάθησης προσαρμοσμένο στους στόχους σας",
        "web.quiz.3min": "Τρίλεπτο τεστ",
        "web.profile.age": "Η ηλικία σας",
        "web.unlock.english.potential": "Ξεκλειδώστε τις δυνατότητές σας στα αγγλικά",
        "screen.practice.guide.control.next": "Επόμενο",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " και ",
        "web.common.privacyPolicy": "Πολιτική Απορρήτου",
        "web.common.ratingAlt": "5 στα 5 αστέρια",
        "web.common.termsOfUse": "Όροι Χρήσης",
        "web.start.heroAlt": "Η Λόλα, η AI καθηγήτριά σας",
        "web.start.statsLabel": "Πάνω από 2 εκατ. χρήστες, μέση βαθμολογία 4,8, πάνω από 125.000 αξιολογήσεις",
        "web.start.title": "Μιλήστε αγγλικά με περισσότερη αυτοπεποίθηση",
        "web.start.review1.text": "Εξαιρετική εφαρμογή για εξάσκηση στην ομιλία. Μαθαίνετε με τον δικό σας ρυθμό, χωρίς περιορισμούς",
        "web.start.review1.author": "Τίνα",
        "web.start.review2.text": "Εφαρμογή για εξάσκηση στις συζητήσεις που χρειάζεστε για τη ζωή στις ΗΠΑ 🙂",
        "web.start.review2.author": "Μπόρις",
        "web.start.review3.text": "Μια εφαρμογή που σας βάζει να μιλάτε πολύ ήπια, χωρίς άγχος",
        "web.start.review3.author": "Λουσία",
        "onboarding.good.company.average.rating": "μέση βαθμολογία",
        "onboarding.good.company.ratings": "αξιολογήσεις",
        "screen.paywall.users": "χρήστες",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125.000+",
        "web.start.statUsersValue": "2+ εκατ."
    },
    "no": {
        "web.personalized.plan": "Få en personlig læreplan tilpasset dine mål",
        "web.quiz.3min": "3-minutters quiz",
        "web.profile.age": "Alderen din",
        "web.unlock.english.potential": "Lås opp ditt engelske potensial",
        "screen.practice.guide.control.next": "Neste",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " og ",
        "web.common.privacyPolicy": "Personvernerklæring",
        "web.common.ratingAlt": "5 av 5 stjerner",
        "web.common.termsOfUse": "Vilkår for bruk",
        "web.start.heroAlt": "Lola, din AI-lærer",
        "web.start.statsLabel": "Over 2 millioner brukere, snittvurdering 4,8, over 125 000 vurderinger",
        "web.start.title": "Snakk engelsk med mer selvtillit",
        "web.start.review1.text": "Flott app for å øve på å snakke. Du kan jobbe i ditt eget tempo uten begrensninger",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "En app for å øve på samtaler man trenger for å bo i USA 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "En app som får deg til å snakke på en veldig skånsom måte, uten stress",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "gjennomsnittlig vurdering",
        "onboarding.good.company.ratings": "rangeringer",
        "screen.paywall.users": "brukere",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ millioner"
    },
    "pl": {
        "web.personalized.plan": "Otrzymaj spersonalizowany plan nauki dopasowany do Twoich celów",
        "web.quiz.3min": "3-minutowy quiz",
        "web.profile.age": "Państwa wiek",
        "web.unlock.english.potential": "Odblokuj swój potencjał w języku angielskim",
        "screen.practice.guide.control.next": "Dalej",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " i ",
        "web.common.privacyPolicy": "Polityka prywatności",
        "web.common.ratingAlt": "5 na 5 gwiazdek",
        "web.common.termsOfUse": "Warunki korzystania",
        "web.start.heroAlt": "Lola – tutorka AI",
        "web.start.statsLabel": "Ponad 2 mln użytkowników, średnia ocena 4,8, ponad 125 000 ocen",
        "web.start.title": "Więcej pewności w mówieniu po angielsku",
        "web.start.review1.text": "Świetna aplikacja do ćwiczenia mówienia. Można uczyć się we własnym tempie, bez ograniczeń",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Aplikacja do ćwiczenia rozmów potrzebnych do życia w USA 🙂",
        "web.start.review2.author": "Borys",
        "web.start.review3.text": "Aplikacja, która bardzo łagodnie i bez stresu ośmiela do mówienia",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "średnia ocena",
        "onboarding.good.company.ratings": "ocen",
        "screen.paywall.users": "użytkowników",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ mln"
    },
    "sv": {
        "web.personalized.plan": "Få en personlig studieplan anpassad efter dina mål",
        "web.quiz.3min": "3-minuters quiz",
        "web.profile.age": "Din ålder",
        "web.unlock.english.potential": "Lås upp din engelska potential",
        "screen.practice.guide.control.next": "Nästa",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " och ",
        "web.common.privacyPolicy": "Integritetspolicy",
        "web.common.ratingAlt": "5 av 5 stjärnor",
        "web.common.termsOfUse": "Användarvillkor",
        "web.start.heroAlt": "Lola, din AI-lärare",
        "web.start.statsLabel": "Över 2 miljoner användare, snittbetyg 4,8, över 125 000 betyg",
        "web.start.title": "Tala engelska med större självförtroende",
        "web.start.review1.text": "Bra app för att öva på att prata. Du kan plugga i din egen takt utan begränsningar",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "En app för att öva på samtal man behöver för att leva i USA 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "En app som får dig att prata på ett väldigt mjukt sätt, utan stress",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "medelbetyg",
        "onboarding.good.company.ratings": "betyg",
        "screen.paywall.users": "användare",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ miljoner"
    },
    "tr": {
        "web.personalized.plan": "Hedeflerine göre özelleştirilmiş bir öğrenme planı al",
        "web.quiz.3min": "3 dakikalık test",
        "web.profile.age": "Yaşınız",
        "web.unlock.english.potential": "İngilizce potansiyelini ortaya çıkar",
        "screen.practice.guide.control.next": "Sonraki",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " ve ",
        "web.common.privacyPolicy": "Gizlilik Politikası",
        "web.common.ratingAlt": "5 üzerinden 5 yıldız",
        "web.common.termsOfUse": "Kullanım Koşulları",
        "web.start.heroAlt": "Yapay zekâ öğretmeniniz Lola",
        "web.start.statsLabel": "2 milyondan fazla kullanıcı, ortalama 4,8 puan, 125.000'den fazla değerlendirme",
        "web.start.title": "İngilizceyi daha özgüvenle konuşun",
        "web.start.review1.text": "Konuşma pratiği için harika bir uygulama. Hiçbir kısıtlama olmadan kendi temponuzda çalışabiliyorsunuz",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "ABD'de yaşamak için gereken konuşmaları çalışmaya yönelik bir uygulama 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Sizi çok nazik bir şekilde, stres yaşatmadan konuşturan bir uygulama",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "ortalama puan",
        "onboarding.good.company.ratings": "değerlendirme",
        "screen.paywall.users": "kullanıcı",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125.000+",
        "web.start.statUsersValue": "2 milyon+"
    },
    "en": {
        "web.personalized.plan": "Get a personalized learning plan tailored to your goals",
        "web.quiz.3min": "3 minute quiz",
        "web.profile.age": "Your age",
        "web.unlock.english.potential": "Unlock your English potential",
        "screen.practice.guide.control.next": "Next",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " & ",
        "web.common.privacyPolicy": "Privacy Policy",
        "web.common.ratingAlt": "5 out of 5 stars",
        "web.common.termsOfUse": "Terms of Use",
        "web.start.heroAlt": "Lola, your AI tutor",
        "web.start.statsLabel": "2+ million users, 4.8 average rating, 125,000+ ratings",
        "web.start.title": "Speak English with more confidence",
        "web.start.review1.text": "Great app for speaking practice. You can work at your own pace without limitations",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Application for practicing conversations necessary for living in the USA 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "An app that gets you speaking in a very gentle way, without stress",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "average rating",
        "onboarding.good.company.ratings": "ratings",
        "screen.paywall.users": "users",
        "web.start.statRatingValue": "4.8",
        "web.start.statRatingsValue": "125,000+",
        "web.start.statUsersValue": "2+ million"
    },
    "fi": {
        "web.personalized.plan": "Hanki henkilökohtainen oppimissuunnitelma tavoitteidesi mukaan",
        "web.quiz.3min": "3 minuutin testi",
        "web.profile.age": "Ikäsi",
        "web.unlock.english.potential": "Avaa englannin kielen potentiaalisi",
        "screen.practice.guide.control.next": "Seuraava",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " ja ",
        "web.common.privacyPolicy": "Tietosuojakäytäntö",
        "web.common.ratingAlt": "5 tähteä viidestä",
        "web.common.termsOfUse": "Käyttöehdot",
        "web.start.heroAlt": "Lola, tekoälyopettajasi",
        "web.start.statsLabel": "Yli 2 miljoonaa käyttäjää, keskiarvo 4,8, yli 125 000 arviota",
        "web.start.title": "Puhu englantia varmemmin",
        "web.start.review1.text": "Loistava sovellus puhumisen harjoitteluun. Voit edetä omaan tahtiisi ilman rajoituksia",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Sovellus Yhdysvalloissa elämiseen tarvittavien keskustelujen harjoitteluun 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Sovellus, joka saa sinut puhumaan todella lempeästi, ilman stressiä",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "arvioiden keskiarvo",
        "onboarding.good.company.ratings": "arviota",
        "screen.paywall.users": "käyttäjiä",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ miljoonaa"
    },
    "fr": {
        "web.personalized.plan": "Obtenez un plan d'apprentissage personnalisé adapté à vos objectifs",
        "web.quiz.3min": "Quiz de 3 minutes",
        "web.profile.age": "Votre âge",
        "web.unlock.english.potential": "Libérez votre potentiel en anglais",
        "screen.practice.guide.control.next": "Suivant",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " et ",
        "web.common.privacyPolicy": "Politique de confidentialité",
        "web.common.ratingAlt": "5 étoiles sur 5",
        "web.common.termsOfUse": "Conditions d'utilisation",
        "web.start.heroAlt": "Lola, votre tutrice IA",
        "web.start.statsLabel": "Plus de 2 millions d'utilisateurs, note moyenne de 4,8, plus de 125 000 avis",
        "web.start.title": "Parlez anglais avec plus d'assurance",
        "web.start.review1.text": "Super appli pour pratiquer l'oral. On avance à son rythme, sans limites",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Une appli pour s'entraîner aux conversations utiles pour vivre aux États-Unis 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Une appli qui vous fait parler tout en douceur, sans stress",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "note moyenne",
        "onboarding.good.company.ratings": "notes",
        "screen.paywall.users": "utilisateurs",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ millions"
    },
    "es": {
        "web.personalized.plan": "Obtén un plan de aprendizaje personalizado adaptado a su objetivos",
        "web.quiz.3min": "Cuestionario de 3 minutos",
        "web.profile.age": "Su edad",
        "web.unlock.english.potential": "Desbloquea su potencial en inglés",
        "screen.practice.guide.control.next": "Siguiente",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " y ",
        "web.common.privacyPolicy": "Política de privacidad",
        "web.common.ratingAlt": "5 de 5 estrellas",
        "web.common.termsOfUse": "Términos de uso",
        "web.start.heroAlt": "Lola, su tutora de IA",
        "web.start.statsLabel": "Más de 2 millones de usuarios, valoración media de 4,8, más de 125.000 valoraciones",
        "web.start.title": "Hable inglés con más confianza",
        "web.start.review1.text": "Una app genial para practicar conversación. Avanzas a tu ritmo, sin limitaciones",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Una app para practicar las conversaciones necesarias para vivir en EE. UU. 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Una app que te hace hablar de forma muy suave, sin estrés",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "valoración media",
        "onboarding.good.company.ratings": "calificaciones",
        "screen.paywall.users": "usuarios",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125.000+",
        "web.start.statUsersValue": "2+ millones"
    },
    "nl": {
        "web.personalized.plan": "Ontvang een gepersonaliseerd leerplan afgestemd op jouw doelen",
        "web.quiz.3min": "3 minuten quiz",
        "web.profile.age": "Uw leeftijd",
        "web.unlock.english.potential": "Ontgrendel je Engels potentieel",
        "screen.practice.guide.control.next": "Volgende",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " en ",
        "web.common.privacyPolicy": "Privacybeleid",
        "web.common.ratingAlt": "5 van 5 sterren",
        "web.common.termsOfUse": "Gebruiksvoorwaarden",
        "web.start.heroAlt": "Lola, uw AI-tutor",
        "web.start.statsLabel": "Meer dan 2 miljoen gebruikers, gemiddelde beoordeling 4,8, meer dan 125.000 beoordelingen",
        "web.start.title": "Spreek Engels met meer zelfvertrouwen",
        "web.start.review1.text": "Geweldige app om spreken te oefenen. U werkt in uw eigen tempo, zonder beperkingen",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "App om gesprekken te oefenen die nodig zijn om in de VS te wonen 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Een app die u heel rustig aan het praten krijgt, zonder stress",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "gemiddelde beoordeling",
        "onboarding.good.company.ratings": "waarderingen",
        "screen.paywall.users": "gebruikers",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125.000+",
        "web.start.statUsersValue": "2+ miljoen"
    },
    "bg": {
        "web.personalized.plan": "Вземете персонализиран учебен план, съобразен с вашите цели",
        "web.quiz.3min": "3-минутен тест",
        "web.profile.age": "Вашата възраст",
        "web.unlock.english.potential": "Отключете своя потенциал по английски",
        "screen.practice.guide.control.next": "Напред",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " и ",
        "web.common.privacyPolicy": "Политика за поверителност",
        "web.common.ratingAlt": "5 от 5 звезди",
        "web.common.termsOfUse": "Условия за ползване",
        "web.start.heroAlt": "Лола, вашата ИИ преподавателка",
        "web.start.statsLabel": "Над 2 млн потребители, средна оценка 4,8, над 125 000 оценки",
        "web.start.title": "Говорете английски по-уверено",
        "web.start.review1.text": "Чудесно приложение за разговорна практика. Учите със собствено темпо, без ограничения",
        "web.start.review1.author": "Тина",
        "web.start.review2.text": "Приложение за упражняване на разговори, нужни за живота в САЩ 🙂",
        "web.start.review2.author": "Борис",
        "web.start.review3.text": "Приложение, което много нежно и без стрес ви помага да проговорите",
        "web.start.review3.author": "Лусия",
        "onboarding.good.company.average.rating": "средна оценка",
        "onboarding.good.company.ratings": "оценки",
        "screen.paywall.users": "потребители",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ млн"
    },
    "nb": {
        "web.personalized.plan": "Få en personlig læreplan tilpasset dine mål",
        "web.quiz.3min": "3-minutters quiz",
        "web.profile.age": "Alderen din",
        "web.unlock.english.potential": "Lås opp ditt engelske potensial",
        "screen.practice.guide.control.next": "Neste",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " og ",
        "web.common.privacyPolicy": "Personvernerklæring",
        "web.common.ratingAlt": "5 av 5 stjerner",
        "web.common.termsOfUse": "Vilkår for bruk",
        "web.start.heroAlt": "Lola, din AI-lærer",
        "web.start.statsLabel": "Over 2 millioner brukere, snittvurdering 4,8, over 125 000 vurderinger",
        "web.start.title": "Snakk engelsk med mer selvtillit",
        "web.start.review1.text": "Flott app for å øve på å snakke. Du kan jobbe i ditt eget tempo uten begrensninger",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "En app for å øve på samtaler man trenger for å bo i USA 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "En app som får deg til å snakke på en veldig skånsom måte, uten stress",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "gjennomsnittlig vurdering",
        "onboarding.good.company.ratings": "rangeringer",
        "screen.paywall.users": "brukere",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ millioner"
    },
    "hi": {
        "web.personalized.plan": "अपने लक्ष्यों के अनुसार तैयार किया गया व्यक्तिगत लर्निंग प्लान प्राप्त करें",
        "web.quiz.3min": "3 मिनट का क्विज़",
        "web.profile.age": "आपकी आयु",
        "web.unlock.english.potential": "अपनी अंग्रेज़ी की क्षमता को अनलॉक करें",
        "screen.practice.guide.control.next": "अगला",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " और ",
        "web.common.privacyPolicy": "गोपनीयता नीति",
        "web.common.ratingAlt": "5 में से 5 स्टार",
        "web.common.termsOfUse": "उपयोग की शर्तें",
        "web.start.heroAlt": "लोला, आपकी एआई ट्यूटर",
        "web.start.statsLabel": "20 लाख से ज़्यादा उपयोगकर्ता, औसत रेटिंग 4.8, 1,25,000 से ज़्यादा रेटिंग",
        "web.start.title": "ज़्यादा आत्मविश्वास से अंग्रेज़ी बोलें",
        "web.start.review1.text": "बोलने के अभ्यास के लिए बढ़िया ऐप। आप बिना किसी पाबंदी के अपनी रफ़्तार से सीख सकते हैं",
        "web.start.review1.author": "टीना",
        "web.start.review2.text": "अमेरिका में रहने के लिए ज़रूरी बातचीत का अभ्यास करने वाला ऐप 🙂",
        "web.start.review2.author": "बोरिस",
        "web.start.review3.text": "एक ऐप जो बहुत सहज तरीके से, बिना तनाव के आपको बोलना सिखाता है",
        "web.start.review3.author": "लूसिया",
        "onboarding.good.company.average.rating": "औसत रेटिंग",
        "onboarding.good.company.ratings": "रेटिंग",
        "screen.paywall.users": "उपयोगकर्ताओं",
        "web.start.statRatingValue": "4.8",
        "web.start.statRatingsValue": "1,25,000+",
        "web.start.statUsersValue": "20 लाख+"
    },
    "de": {
        "web.personalized.plan": "Erhalte einen personalisierten Lernplan, der auf deine Ziele zugeschnitten ist",
        "web.quiz.3min": "3-Minuten-Quiz",
        "web.profile.age": "Ihr Alter",
        "web.unlock.english.potential": "Entfalte dein Englischpotenzial",
        "screen.practice.guide.control.next": "Weiter",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " und ",
        "web.common.privacyPolicy": "Datenschutzerklärung",
        "web.common.ratingAlt": "5 von 5 Sternen",
        "web.common.termsOfUse": "Nutzungsbedingungen",
        "web.start.heroAlt": "Lola, Ihre KI-Tutorin",
        "web.start.statsLabel": "Über 2 Millionen Nutzer, Durchschnittsbewertung 4,8, über 125.000 Bewertungen",
        "web.start.title": "Sprechen Sie selbstbewusster Englisch",
        "web.start.review1.text": "Tolle App fürs Sprechtraining. Man lernt im eigenen Tempo, ganz ohne Einschränkungen",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Eine App zum Üben von Gesprächen, die man für das Leben in den USA braucht 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Eine App, die einen ganz sanft und ohne Stress zum Sprechen bringt",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "durchschnittliche Bewertung",
        "onboarding.good.company.ratings": "Bewertungen",
        "screen.paywall.users": "Benutzer",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125.000+",
        "web.start.statUsersValue": "2+ Mio."
    },
    "ko": {
        "web.personalized.plan": "목표에 맞춘 맞춤형 학습 계획을 받아보세요",
        "web.quiz.3min": "3분 퀴즈",
        "web.profile.age": "귀하의 나이",
        "web.unlock.english.potential": "영어 실력을 최대한 끌어올리세요",
        "screen.practice.guide.control.next": "다음",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " 및 ",
        "web.common.privacyPolicy": "개인정보 처리방침",
        "web.common.ratingAlt": "별점 5점 만점에 5점",
        "web.common.termsOfUse": "이용약관",
        "web.start.heroAlt": "AI 튜터 롤라",
        "web.start.statsLabel": "사용자 200만 명 이상, 평균 평점 4.8, 평가 125,000건 이상",
        "web.start.title": "더 자신 있게 영어로 말해 보세요",
        "web.start.review1.text": "말하기 연습에 정말 좋은 앱이에요. 제한 없이 내 속도대로 공부할 수 있어요",
        "web.start.review1.author": "티나",
        "web.start.review2.text": "미국 생활에 꼭 필요한 대화를 연습할 수 있는 앱이에요 🙂",
        "web.start.review2.author": "보리스",
        "web.start.review3.text": "스트레스 없이 아주 부드럽게 말문을 열어 주는 앱이에요",
        "web.start.review3.author": "루시아",
        "onboarding.good.company.average.rating": "평균 평점",
        "onboarding.good.company.ratings": "평가",
        "screen.paywall.users": "사용자",
        "web.start.statRatingValue": "4.8",
        "web.start.statRatingsValue": "125,000+",
        "web.start.statUsersValue": "200만+"
    },
    "ar": {
        "web.personalized.plan": "احصل على خطة تعلم مخصصة لأهدافك",
        "web.quiz.3min": "اختبار لمدة 3 دقائق",
        "web.profile.age": "عمرك",
        "web.unlock.english.potential": "اكتشف إمكانياتك في اللغة الإنجليزية",
        "screen.practice.guide.control.next": "التالي",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " و",
        "web.common.privacyPolicy": "سياسة الخصوصية",
        "web.common.ratingAlt": "5 من 5 نجوم",
        "web.common.termsOfUse": "شروط الاستخدام",
        "web.start.heroAlt": "لولا، معلمتك بالذكاء الاصطناعي",
        "web.start.statsLabel": "أكثر من 2 مليون مستخدم، متوسط تقييم 4.8، أكثر من 125,000 تقييم",
        "web.start.title": "تحدّث الإنجليزية بثقة أكبر",
        "web.start.review1.text": "تطبيق رائع لممارسة المحادثة. يمكنك التعلم بالسرعة التي تناسبك دون أي قيود",
        "web.start.review1.author": "تينا",
        "web.start.review2.text": "تطبيق للتدرّب على المحادثات التي تحتاجها للعيش في الولايات المتحدة 🙂",
        "web.start.review2.author": "بوريس",
        "web.start.review3.text": "تطبيق يشجّعك على الكلام بطريقة لطيفة جدًا ودون توتر",
        "web.start.review3.author": "لوسيا",
        "onboarding.good.company.average.rating": "متوسط تقييم",
        "onboarding.good.company.ratings": "التقييمات",
        "screen.paywall.users": "المستخدمون",
        "web.start.statRatingValue": "4.8",
        "web.start.statRatingsValue": "+125,000",
        "web.start.statUsersValue": "+2 مليون"
    },
    "pt": {
        "web.personalized.plan": "Obtém um plano de aprendizagem personalizado adaptado aos teus objetivos",
        "web.quiz.3min": "Questionário de 3 minutos",
        "web.profile.age": "A sua idade",
        "web.unlock.english.potential": "Desbloqueia o teu potencial em inglês",
        "screen.practice.guide.control.next": "Seguinte",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " e ",
        "web.common.privacyPolicy": "Política de Privacidade",
        "web.common.ratingAlt": "5 de 5 estrelas",
        "web.common.termsOfUse": "Termos de Utilização",
        "web.start.heroAlt": "Lola, a sua tutora de IA",
        "web.start.statsLabel": "Mais de 2 milhões de utilizadores, classificação média de 4,8, mais de 125 000 avaliações",
        "web.start.title": "Fale inglês com mais confiança",
        "web.start.review1.text": "Ótima aplicação para praticar conversação. Pode estudar ao seu ritmo, sem limitações",
        "web.start.review1.author": "Tina",
        "web.start.review2.text": "Aplicação para praticar as conversas necessárias para viver nos EUA 🙂",
        "web.start.review2.author": "Boris",
        "web.start.review3.text": "Uma aplicação que nos põe a falar de forma muito suave, sem stress",
        "web.start.review3.author": "Lucia",
        "onboarding.good.company.average.rating": "classificação média",
        "onboarding.good.company.ratings": "classificações",
        "screen.paywall.users": "utilizadores",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ milhões"
    },
    "zh": {
        "web.personalized.plan": "获取一个根据你的目标定制的个性化学习计划",
        "web.quiz.3min": "3分钟测验",
        "web.profile.age": "您的年龄",
        "web.unlock.english.potential": "解锁你的英语潜能",
        "screen.practice.guide.control.next": "下一步",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": "和",
        "web.common.privacyPolicy": "隐私政策",
        "web.common.ratingAlt": "5 星（满分 5 星）",
        "web.common.termsOfUse": "使用条款",
        "web.start.heroAlt": "罗拉，您的 AI 导师",
        "web.start.statsLabel": "200 万+ 用户，平均评分 4.8，125,000+ 条评分",
        "web.start.title": "说英语，更自信",
        "web.start.review1.text": "非常适合练习口语的应用。可以按自己的节奏学习，没有任何限制",
        "web.start.review1.author": "蒂娜",
        "web.start.review2.text": "能练习在美国生活所需的日常对话的应用 🙂",
        "web.start.review2.author": "鲍里斯",
        "web.start.review3.text": "这款应用能非常温和地让您开口说话，毫无压力",
        "web.start.review3.author": "露西亚",
        "onboarding.good.company.average.rating": "平均评分",
        "onboarding.good.company.ratings": "评级",
        "screen.paywall.users": "用户",
        "web.start.statRatingValue": "4.8",
        "web.start.statRatingsValue": "125,000+",
        "web.start.statUsersValue": "200 万+"
    },
    "uk": {
        "web.personalized.plan": "Отримай персоналізований план навчання відповідно до своїх цілей",
        "web.quiz.3min": "3-хвилинний тест",
        "web.profile.age": "Ваш вік",
        "web.unlock.english.potential": "Розкрийте свій потенціал в англійській мові",
        "screen.practice.guide.control.next": "Далі",
        "web.common.appName": "Lola Speak",
        "web.common.legalSeparator": " і ",
        "web.common.privacyPolicy": "Політика конфіденційності",
        "web.common.ratingAlt": "5 із 5 зірок",
        "web.common.termsOfUse": "Умови використання",
        "web.start.heroAlt": "Лола, ваша ШІ-репетиторка",
        "web.start.statsLabel": "Понад 2 млн користувачів, середня оцінка 4,8, понад 125 000 оцінок",
        "web.start.title": "Говоріть англійською впевненіше",
        "web.start.review1.text": "Чудовий застосунок для розмовної практики. Займаєтеся у своєму темпі, без обмежень",
        "web.start.review1.author": "Тіна",
        "web.start.review2.text": "Застосунок для тренування розмов, потрібних для життя у США 🙂",
        "web.start.review2.author": "Борис",
        "web.start.review3.text": "Застосунок, який дуже м’яко й без стресу допомагає заговорити",
        "web.start.review3.author": "Лусія",
        "onboarding.good.company.average.rating": "середня оцінка",
        "onboarding.good.company.ratings": "оцінок",
        "screen.paywall.users": "користувачів",
        "web.start.statRatingValue": "4,8",
        "web.start.statRatingsValue": "125 000+",
        "web.start.statUsersValue": "2+ млн"
    }
}
